export default function ({ event_name, properties }) {
  this.sendEvent('analytics.dispatch', { event_name, properties })
}
